import { documentTypeId } from 'Utils/constants'

/**
 * @param {Array} data
 * @returns {Number} - The position of the first valid document found (ODV)
 */
export const getCorrectQuotationPosition = data => {
  const position = data.findIndex(
    item =>
      item.DocumentTypeId?.toUpperCase() ===
      documentTypeId.QUOTATION.toUpperCase()
  )
  return Math.max(position, 0)
}
